import React, { useState, useEffect,useRef } from 'react'
import { connectBalanceInformation } from './BalanceInformation.connect';
import DownArrow from '../../assets/images/svgs/DownArrow.svg?react';
import { getCurrencyFormat } from '../../helpers/getCurrencyFormat.helper'


const BalanceInformation = ({ user, balance, auth, isDetailedBalanceOpen, actions }) => {
  const [isDetailedOpen, setIsDetailedOpen] = useState(false)
  const [elementHeight, setElementHeight] = useState(0);
  const elementRef = useRef(null);


  useEffect(() => {
    if (elementRef?.current?.clientHeight) {
      setElementHeight(elementRef.current?.clientHeight)
      actions.setBalanceInformationHeight(elementRef.current?.clientHeight) 
    }
  }, [elementRef?.current?.clientHeight]);


  return (
    <>
      <div className="flex flex-col w-full gap-1 select-none">
        <div 
          className=" w-full flex px-3 gap-x-1 py-2 relative cursor-pointer rounded bg-bg_Secondary"
          onClick={() => {setIsDetailedOpen(!isDetailedOpen);}}
        >
          <div className="flex flex-col items-start ">
            <span className="uppercase text-text_Quaternary font-normal text-xxs">
              Available Credit
            </span>
            <span className="text-text_Quaternary font-lato text-sm"> {balance && balance.balance ? getCurrencyFormat(balance.balance)  : 0}</span>
          </div>
          <div className={`absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer mr-2 flex items-center justify-center autoAnimate  ${isDetailedOpen? '-rotate-180' : ''}`}>
            <DownArrow />
          </div>
        </div>
        <div
          className="overflow-hidden transition-height duration-100 ease-in-out  "
          style={{height: isDetailedOpen? elementHeight : 0}}
        >
          <div ref={elementRef} className="flex flex-col gap-1  border autoAnimate rounded-lg opacity-100">
            <div className=" grid grid-cols-2 gap-1 w-full p-1">
              <div className="flex w-full flex-col rounded items-start text-text_Ternary-new bg-bg_Ternary8 border px-2 py-1 col-span-2">
                <span className="uppercase  font-normal text-xxs">Balance</span>
                <span className=" font-lato text-sm"> {balance && balance.balance ? getCurrencyFormat(balance.balance)  : 0.00.toFixed(2)}</span>
              </div>
              <div className="flex w-full flex-col rounded items-start bg-bg_Ternary8 text-text_Ternary-new border px-2 py-1 ">
                <span className="uppercase  font-normal text-xxs">Free Cash</span>
                <span className=" font-lato text-sm"> 0.00</span>
              </div>
              <div className="flex w-full flex-col rounded items-start bg-bg_Ternary8 text-text_Ternary-new border px-2 py-1 ">
                <span className="uppercase  font-normal text-xxs">Net Exposure</span>
                <span className=" font-lato text-sm"> {balance && balance.liability ? getCurrencyFormat(balance.liability)  : 0.00.toFixed(2)}</span>
              </div>
            </div>
            
            <div title="sWalletInfo"></div>
          </div>

        </div>
      </div>
    </>
  )
}

export default connectBalanceInformation()(BalanceInformation)
